module.exports = __webpack_public_path__ + "img/KV.8ac36ea2.png";